/**
 * The catalog of homepage experiments — their variants and weights. An
 * experiment runs only when its key is in the `EXPERIMENTS` runtime config (see
 * `config.ts` / docs/experimentation.md); listing it here defines it, it does
 * not enable it.
 *
 * A variant's *content* lives where it renders: the seams are conditional
 * renders in `Home.tsx` keyed on the assigned variant, not a content object
 * here.
 */

import type { Experiment } from './experiment-assignment.ts';

// Every defined experiment. None is defined at the moment; an entry looks like
// `{ key: 'homepage_<name>_v1', variants: [{ key: 'control', weight: 1 },
// { key: 'treatment', weight: 1 }] }` (equal weights give a 50/50 split), with
// its render seam gated in `Home.tsx` on `getVariant(key)`.
export const EXPERIMENTS: Experiment[] = [];
